<template>
  <v-dialog v-model="dialog" width="90%">

    <v-card elevation="3">
      <div class="pp-sidenav white">
        <v-card-title>
          Publish a New Course
        </v-card-title>

        <v-card-subtitle>
          Add details below
        </v-card-subtitle>
      </div>

      <v-img
          src="/images/pp-logo.png"
          height="40"
          contain
          class="logo-course"
      >
      </v-img>

      <template>
        <v-stepper
            non-linear
            v-model="e1">
          <v-stepper-header class="secondary darken-3">
            <v-stepper-step
                :complete="e1 > 1"
                step="1"
                editable
            >
              <div class="white--text">
                Course Details
              </div>
            </v-stepper-step>

            <v-divider class="secondary" />

            <v-stepper-step
                :complete="e1 > 2"
                step="2"
                editable
            >
              <div class="white--text">
                Add Resources
              </div>
            </v-stepper-step>

            <v-divider class="secondary" />

            <v-stepper-step
                :complete="e1 > 3"
                step="3"
                editable
            >
              <div class="white--text">
                Order Resources
              </div>
            </v-stepper-step>

            <v-divider class="secondary" />

            <v-stepper-step
                step="4"
                editable
            >
              <div class="white--text">
                Review Course
              </div>
            </v-stepper-step>
          </v-stepper-header>

          <!-- Stepper Content -->

          <v-stepper-items>
            <v-stepper-content step="1">

              <v-card flat>
                <v-container>
                  <template>
                    <v-card
                        color="grey lighten-4"
                        width="100%" flat
                    >
                      <v-card-title class="text-h6 grey lighten-3">
                        Add Course Details
                      </v-card-title>

                      <div class="py-5 px-2">
                        <v-card-text>
                          <v-text-field
                              v-model="item.name"
                              aria-required="true"
                              color="primary"
                              label="Add a Course Title"
                              placeholder="Add a Course Title"
                              prepend-icon="mdi-file-edit-outline"
                              flat
                              solo
                              clearable
                          >
                          </v-text-field>

                          <v-row
                              class="err-text ma-1"
                              v-if="courseApiError && courseApiError.fields && courseApiError.fields.name"
                          >
                            <p class="error--text">
                              Course name should not be empty and contain letters and/or numbers.
                            </p>
                          </v-row>

                          <v-row>
                            <v-col>
                              <v-row class="ml-1">
                                <v-text-field
                                    v-model="item.priceInUnits"
                                    label="Price (in unit)"
                                    aria-required="true"
                                    color="primary"
                                    hint="Price in Unit (e.g: 3045 for £30.45)"
                                    placeholder="Price in Unit (e.g: 3045 for £30.45)"
                                    prepend-icon="mdi-currency-gbp"
                                    flat
                                    solo
                                    clearable
                                    persistent-hint
                                ></v-text-field>
                              </v-row>

                              <v-row
                                  v-if="courseApiError && courseApiError.fields && courseApiError.fields.priceInUnits">
                                <p class="error--text">
                                  Set a course price.
                                </p>
                              </v-row>
                            </v-col>
                            <v-col>
                              <v-row class="ml-4">
                                <v-select
                                    aria-required="true"
                                    color="primary"
                                    hint="Select a Currency"
                                    placeholder="Select a Currency"
                                    prepend-icon="mdi-cash"
                                    flat
                                    solo
                                    clearable
                                    persistent-hint
                                    v-model="item.currency"
                                    :items="courseCurrencies"
                                    label="Currency"
                                ></v-select>
                              </v-row>

                              <v-row
                                  class="err-text mt-5 ml-5"
                                  v-if="courseApiError && courseApiError.fields && courseApiError.fields.currency">
                                <p class="error--text">
                                  Select a currency.
                                </p>
                              </v-row>
                            </v-col>

                            <v-col>
                              <v-row class="ml-10 mb-5">
                                <v-icon class="mr-4" color="primary">
                                  mdi-heart
                                </v-icon>
                                <v-switch
                                    v-model="item.popular"
                                    class="v-input--reverse"
                                    hint="Is this course popular?"
                                    persistent-hint
                                >
                                  <template #label>
                                    Popular
                                  </template>
                                </v-switch>
                              </v-row>

                              <v-row
                                  class="err-text"
                                  v-if="courseApiError && courseApiError.fields && courseApiError.fields.popular">
                                <p class="error--text">
                                  Popular should be true or false.
                                </p>
                              </v-row>
                            </v-col>
                          </v-row>

                          <div class="pl-3">
                            <v-row>
                              <v-textarea
                                  v-model="item.description"
                                  auto-grow
                                  hint="The description of the course will be publicly visible"
                                  persistent-hint
                                  label="Add Course Description"
                                  aria-required="true"
                                  color="primary"
                                  placeholder="Add Course Description"
                                  prepend-icon="mdi-format-line-style"
                                  flat
                                  solo
                                  clearable
                              >
                              </v-textarea>
                            </v-row>

                            <v-row
                                class="err-text mt-6"
                                v-if="courseApiError && courseApiError.fields && courseApiError.fields.description">
                              <p class="error--text">
                                Course description should be set.
                              </p>
                            </v-row>

                            <v-row class="mt-10">
                              <Suggest
                                  label="Select Course Level (Optional)"
                                  placeholder="Start typing to select Course Level (Optional)"
                                  :ariaRequired=true
                                  prepend-icon="mdi-numeric"
                                  color="primary"
                                  hide-no-data
                                  :flat=true
                                  :solo=true
                                  :clearable=true
                                  :multiple=false
                                  searchType="level"
                                  :select=selectLevel
                                  :modelSelected=item.level
                              />
                            </v-row>

                            <v-row class="mt-5">
                              <Suggest
                                  label="Select Awarding Body (Optional)"
                                  placeholder="Start typing to start typing to select Awarding Body (Optional)"
                                  prepend-icon="mdi-seal-variant"
                                  color="primary"
                                  :ariaRequired=true
                                  hide-no-data
                                  :flat=true
                                  :solo=true
                                  :clearable=true
                                  :multiple=false
                                  searchType="awardingBody"
                                  :select=selectAwardingBody
                                  :modelSelected=item.certificationBody
                              />
                            </v-row>

                            <v-row class="mt-5">
                              <Suggest
                                  label="Select Course Categories"
                                  placeholder="Start typing to select Course Categories"
                                  :ariaRequired=true
                                  prepend-icon="mdi-folder-multiple-plus-outline"
                                  color="primary"
                                  :flat=true
                                  hide-no-data
                                  :solo=true
                                  :clearable=true
                                  :multiple=true
                                  searchType="categories"
                                  :select=selectCategories
                                  :modelSelected=item.categories
                              />
                            </v-row>

                            <v-row
                                class="err-text"
                                v-if="courseApiError && courseApiError.fields && courseApiError.fields.categories">
                              <p class="error--text">
                                At least one category should be selected.
                              </p>
                            </v-row>

                            <ImagePicker v-model="item.image"/>

                            <TagsInput
                                v-model="item.tags"
                                :validationError="courseApiError"
                            />

                            <v-btn
                                class="float-right px-10 mt-15 my-5"
                                dark
                                x-large
                                rounded
                                color="primary"
                                @click="e1 = 2"
                            >
                              Continue to Add Resources
                            </v-btn>
                          </div>
                        </v-card-text>
                      </div>
                    </v-card>
                  </template>
                </v-container>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">

              <v-card flat>
                <v-container>
                  <template>
                    <v-card
                        color="grey lighten-4"
                        width="100%" flat
                    >
                      <v-card-title class="text-h6 grey lighten-3">
                        Add Course Resources
                      </v-card-title>

                      <div class="py-5 px-2 ma-5">

                        <v-row>
                          Search and select the resources for this course.
                        </v-row>

                        <v-row class="mt-10">
                          <Resources :update=updateResources :items=item.resources />
                        </v-row>

                        <v-row>
                          <ResourceResultCard :reorder=updateResources :items=item.resources>
                            <template v-slot:scorm="slotProps">
                              <ResourceScorm :scorm="slotProps.scorm"
                              class="mb-7"
                              />
                            </template>
                            <template v-slot:video="slotProps">
                              <ResourceVideo :video="slotProps.video" />
                            </template>
                          </ResourceResultCard>
                        </v-row>

                      </div>
                    </v-card>
                  </template>
                </v-container>
              </v-card>

              <v-btn
                  class="float-right px-10 mt-15 my-5"
                  dark
                  x-large
                  rounded
                  color="primary"
                  @click="e1 = 3"
              >
                Continue to Order Resources
              </v-btn>

              <v-btn
                  @click="e1 = 1"
                  class="px-10 mt-15 my-5 lighten-2"
                  dark
                  x-large
                  rounded
                  color="secondary"
              >
                Back to Course Details
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card flat>
                <v-container>
                  <template>
                    <v-card
                        color="grey lighten-4"
                        width="100%" flat
                    >
                      <v-card-title class="text-h6 grey lighten-3">
                        Order Resources
                      </v-card-title>

                      <div class="py-5 px-2">
                        <v-row class="ma-5">
                          Drag and drop the resources to arrange them in order.
                        </v-row>

                        <v-row>
                          <v-card flat
                                  color="transparent"
                                  width="100%"
                          >
                            <Sortable :reorder=updateResources :items=item.resources>
                              <template v-slot:scorm="slotProps">
                                <ResourceScorm :scorm="slotProps.scorm" />
                              </template>
                              <template v-slot:video="slotProps">
                                <ResourceVideo :video="slotProps.video" />
                              </template>
                            </Sortable>
                          </v-card>
                        </v-row>
                      </div>
                    </v-card>
                  </template>
                </v-container>
              </v-card>

              <v-btn
                  class="float-right px-10 mt-15 my-5"
                  dark
                  x-large
                  rounded
                  color="primary"
                  @click="e1 = 4"
              >
                Continue to Review Details
              </v-btn>

              <v-btn
                  @click="e1 = 2"
                  class="px-10 mt-15 my-5 lighten-2"
                  dark
                  x-large
                  rounded
                  color="secondary"
              >
                Back to Add Resources
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">

              <ReviewDetails :item="item" />

              <div>

                <Loading  v-if="courseItemLoading" />

                <ConfirmCancelButtons
                    :item="item"
                    :confirm-disabled="courseItemLoading"
                    :confirm-action="addItemConfirm"
                    :cancel-action="closeDialog"
                    confirm-text="Create New Course"
                />
              </div>
            </v-stepper-content>
          </v-stepper-items>

          <!--End of Stepper Content -->
        </v-stepper>
      </template>
    </v-card>
  </v-dialog>

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ImagePicker from "@/components/common/ImagePicker";
import Suggest from "@/components/common/Suggest";
import Resources from "@/components/Courses/Resources";
import Sortable from "@/components/common/Sortable";
import ResourceScorm from "@/components/Courses/ResourceScorm";
import ResourceVideo from "@/components/Courses/ResourceVideo";
import ResourceResultCard from "@/components/common/ResourceResultCard";
import ReviewDetails from "@/components/Courses/ReviewDetails";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import Loading from "@/components/common/Loading";
import TagsInput from "@/components/common/TagsInput";

export default {
  name: "CourseAdd",
  components: {
    TagsInput,
    Loading, ConfirmCancelButtons,
    ReviewDetails, ResourceResultCard, ResourceVideo, ResourceScorm, Sortable, Resources, Suggest, ImagePicker,
  },
  data() {
    return {
      e1: 1,
      item: {
        name: '',
        description: '',
        priceInUnits: 0,
        currency: 'gbp',
        image: undefined,
        popular: false,
        level: null,
        certificationBody: null,
        categories: [],
        tags: [],
        resources: [],
      },
    };
  },
  computed: {
    ...mapGetters([
      'courseApiError', 'openDialog', 'courseItemLoading', 'courseCurrencies',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'courseAdd';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },

  methods: {
    ...mapActions([
        'addCourse', 'setOpenDialog', 'closeOpenDialog',
    ]),
    selectLevel(level) {
      this.item.level = level;
    },
    selectAwardingBody(awardingBody) {
      this.item.certificationBody = awardingBody;
    },
    selectCategories(categories) {
      this.item.categories = categories;
    },
    updateResources(resources) {
      this.item.resources = resources;
    },
    closeDialog() {
      this.reset();
    },
    async addItemConfirm() {
      const added = await this.addCourse(this.item);

      if (added) {
        this.reset();
      }
    },
    reset() {
      this.closeOpenDialog();
      this.item = {
        name: '',
        description: '',
        currency: 'gbp',
        priceInUnits: 0,
        popular: false,
        level: null,
        certificationBody: null,
        image: undefined,
        categories: [],
        tags: [],
        resources: [],
      };
    },
  },
};
</script>
